import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import './admin-app.scss';
import { LeftNav } from './left-nav/left-nav';
import { AdminFooter } from './footer/admin-footer';
import { InventoryDashboard } from './inventory-dashboard/inventory-dashboard';
import { WorkOrderList } from './service-and-repair/work-orders/work-order-list';
import { WorkOrderView } from './service-and-repair/work-orders/work-order-page';
import classNames from 'classnames';
import { LegacyView } from '../components/legacy-view/legacy-view';
import { PaymentsReport } from './report/payments/payments-report';
import { CustomerList } from './customer/list/customer-list';
import { AdminHeader } from './header/admin-header';
import { ProductsReport } from './report/products/products-report';
import { ProductList } from './product/list/product-list';
import { QboAccount } from './qbo/qbo-account';
import { UserSetupView } from './customer/page/user-setup';
import { TransactionsReport } from './report/transactions/transaction-report';
import { ToastContainer } from 'react-toastify';
import { CreateMissedRental, CreateOrder, CreateQuote, CreateCreditMemo } from './order/create/create-order';
import { AccountRequests } from './customer/account-requests/account-request-list';
import { LocationList } from './location/list/location-list';
import { CategoryList } from './category/list/category-list';
import { UsersReport } from './report/users/users-report';
import { CustomerSearchesReport } from './report/customer-searches/customer-searches-report';
import React, { useContext, useEffect, useState } from 'react';
import { AdminUsersList } from './admin-users/views/admin-users-list';
import { StripeAccountPage } from './payment-config/stripe-account-setup/stripe-account-page';
import { StripeAccountSetup } from './payment-config/stripe-account-setup/stripe-account-setup';
import { StripeAccountSetupExisting } from './payment-config/stripe-account-setup/stripe-account-setup-existing';
import { AdminProfile } from './admin-users/views/admin-profile';
import { AdminChangePassword } from './admin-users/views/admin-change-password';
import { Collectibles } from './collectibles/collectibles';
import { useAPI } from '../clients/quipli-service/quipli-service-client';
import { CustomerReviews } from './customer/reviews/reviews-list';
import { CustomConnectOnboarding } from './payment-config/stripe-account-setup/custom-connect-onboarding';
import { StripePayments } from './stripe/payments';
import { StripePayouts } from './stripe/payouts';
import { TaxReport } from './report/tax/tax-report';
import { ProductUnitsList } from './product-units/product-units-list';
import { BankDetails } from './stripe/bank-details';
import { TenantContext } from '../context/tenant-context';
import { TerminalList } from './payment-config/stripe-terminal/list/terminal-list';
import { DailyPaymentReport } from './report/payments/daily-payments-report';
import { Messaging } from './messaging/Messaging';
import { AccountTotals } from './accounting/account-totals';
import { AccountingSettings } from './accounting/accounting-settings';
import { AccountLedger } from './accounting/account-ledger';
import { StripePayoutReconciliationReport } from './report/payout/stripe-payout-reconciliation-report';
import { TaxSetup } from './tax-setup/tax-setup';
import { QuipliMate } from './quiplimate/quiplimate';
import { TaxExemptReport } from './report/tax-exempt/tax-exempt-report';
import { DeliveryRevenueReport } from './report/delivery-revenue/delivery-revenue';
import { AccountingPeriodCloseView } from './accounting/accounting-period-close-view';
import { ScheduledServiceList } from './service-and-repair/scheduled-services/scheduled-service-list';
import { ScheduledServicePage } from './service-and-repair/scheduled-services/scheduled-service-page';
import { OrderList } from './order/order-list';
import { OrderViewPage } from './order/view/order-view';
import axios from 'axios';
import { EmailTemplates } from './settings/email-templates/EmailTemplates';
import { SalesCommission } from './report/commission/commission';
import { PaymentMethodConfiguration } from './payment-config/payment-method-config/payment-method-configuration';
import { Revenue } from './report/revenue/revenue';
import { PartList } from './part/list/part-list';
import { ServiceList } from './service/list/service-list';
import { EditTemplate } from './settings/email-templates/EditTemplate';
import { MissedRentalsReport } from './report/missed-rentals/missed-rentals-report';
import { RepresentativeList } from './representatives/representative-role-list';
import { CreateRepresentativeRole, RepresentativeRoleView } from './representatives/representative-role-form';
import { VendorList } from './vendor/vendor-list';
import { VendorView, VendorGeneralForm, VendorAddressForm } from './vendor/vendor-view';
import { InventoryAddEdit } from './inventory-add-edit/inventory-add-edit';
import { CreatePurchaseOrder } from './purchase-order/create/create-purchase-order';
import { JobConfigs } from './job-tasks/job-configs/job-configs';
import { DispatchSelector } from './dispatch-v2/components/dispatch-selector';
import { ScheduleReport } from './report/daily-reports/schedule-report';
import { ReportSchedule } from './report/daily-reports/daily-report-schedule';
import { PurchaseOrderList } from './purchase-order/list/purchase-order-list';
import { PurchaseOrderView } from './purchase-order/view/purchase-order-view';
import { CreditMemoList } from './report/credit-memo/credit-memo-list';
import { DashboardV2 } from './home/dashboard-v2/dashboard-v2';
import useLocalStorage from 'use-local-storage';
import { useResponsive } from '../hooks/use-reponsive';
import { ProductFruitsWrapper } from './product-fruits/product-fruits-wrapper';
import { AdminView } from './admin-users/views/admin-user-view';
import { AdminUserSetup } from './admin-users/views/admin-user-setup';
import { AdminUserPassword } from './admin-users/views/admin-user-password';
import { AdminUserPermissions } from './admin-users/views/admin-user-permissions';
import { AdminUserEmailNotification } from './admin-users/views/admin-user-email-notifications';
import { TagsList } from './customer/tags/tags-list';
import { TagEditAdd } from './customer/tags/tag-add-edit/tag-edit-add';

export const AdminApp = () => {
  const { getMultipleConfigurations } = useAPI();
  const { contextPath } = useContext(TenantContext);
  const { isMobileOrTablet } = useResponsive();

  // State to pass to the left nav
  const [isCollapsed, setIsCollapsed] = useLocalStorage<boolean>('isMenuCollapsed', false);

  const [showPurchaseOrder, setShowPurchaseOrder] = useState<boolean>(false);
  const [showInspections, setInspectionsEnabled] = useState<boolean>(false);
  const [tagPricingV2, setTagPricingV2] = useState<boolean>(false);
  const pathsToRemoveActions = [
    `${contextPath}manager/orders/create`,
    `${contextPath}manager/orders/createMissed`,
    `${contextPath}manager/orders/createCreditMemo`,
    `${contextPath}manager/orders/create_quote`,
    `${contextPath}manager/orders/view/:orderId`,
    `${contextPath}manager/purchase-orders/create`,
    `${contextPath}manager/purchase-orders/:purchaseOrderId`,
  ];
  const [versions, setVersions] = useState<string[]>([]);
  const [showUpgradePrompt, setShowUpgradePrompt] = useState<boolean>(false);

  useEffect(() => {
    function setVhProperty() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--quipli-vh', `${vh}px`);
    }

    setVhProperty();
    window.addEventListener('resize', setVhProperty);
    window.addEventListener('orientationchange', setVhProperty);

    return () => {
      window.removeEventListener('resize', setVhProperty);
      window.removeEventListener('orientationchange', setVhProperty);
    };
  }, []);

  useEffect(() => {
    const checkCreateOrderV2 = async () => {
      const configs = await getMultipleConfigurations([
        'CONF_TAX_EXEMPT_REPORT',
        'CONF_DELIVERY_REVENUE_REPORT',
        'CONF_ENABLE_PURCHASE_ORDERS',
        'CONF_INSPECTIONS_ENABLED',
        'CONF_TAG_PRICING_V2',
      ]);

      setShowPurchaseOrder(configs.find((config) => config.variable === 'CONF_ENABLE_PURCHASE_ORDERS')?.value === '1');
      setInspectionsEnabled(configs.find((config) => config.variable === 'CONF_INSPECTIONS_ENABLED')?.value === '1');
      setTagPricingV2(configs.find((config) => config.variable === 'CONF_TAG_PRICING_V2')?.value === '1');
    };

    checkCreateOrderV2();
  }, []);

  async function getVersion(): Promise<string | undefined> {
    return axios
      .get(`${contextPath}static/version.json`)
      .then((response) => {
        return response.data.version;
      })
      .catch(() => {
        return undefined;
      });
  }

  useEffect(() => {
    const id = setInterval(() => {
      getVersion().then((v) => {
        if (v !== undefined) {
          setVersions((previousVersions) => {
            const newVersions = [...previousVersions, v];
            if (newVersions.length > 3) {
              newVersions.shift();
            }
            return newVersions;
          });
        }
      });
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(id);
    };
  }, []);

  useEffect(() => {
    if (versions && versions.length > 2) {
      const latestVersions = versions.slice(-3);
      if (
        latestVersions[1] === latestVersions[2] &&
        latestVersions[0] !== latestVersions[1] &&
        latestVersions[0] !== latestVersions[2]
      ) {
        setShowUpgradePrompt(true);
      }
    }
  }, [versions]);

  return (
    <>
      <div className={classNames('quipli-v2 app-container', { 'menu-collapsed': isCollapsed })}>
        <div className="nav-container">
          <LeftNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        </div>
        <div className="main-content">
          <ToastContainer />
          <Messaging />
          <QuipliMate />
          <ProductFruitsWrapper />
          <Routes>
            <Route
              path="/"
              element={
                <div className="route-content">
                  {!isMobileOrTablet && (
                    <AdminHeader className="non-legacy" pathsToRemoveActions={pathsToRemoveActions} />
                  )}
                  <div className="grow">
                    <Outlet />
                  </div>
                  <AdminFooter />
                </div>
              }
            >
              <Route path="/" element={<Navigate to={'home'} />} />
              <Route path="/home" element={<DashboardV2 />} />
              <Route path="categories" element={<CategoryList />} />
              <Route path="users" element={<CustomerList />} />
              <Route path="collectibles" element={<Collectibles />} />
              <Route path="users/customer_form/:userId" element={<UserSetupView />} />
              <Route path="users/customer_form/:userId/:tab" element={<UserSetupView />} />
              <Route path="products" element={<ProductList />} />
              <Route path="inventory/parts" element={<PartList />} />
              <Route path="inventory/parts/form" element={<InventoryAddEdit type="Part" />} />
              <Route path="inventory/parts/form/:id" element={<InventoryAddEdit type="Part" />} />
              <Route path="inventory/services" element={<ServiceList />} />
              <Route path="inventory/services/form" element={<InventoryAddEdit type="Service" />} />
              <Route path="inventory/services/form/:id" element={<InventoryAddEdit type="Service" />} />
              <Route path="calendar" element={<InventoryDashboard />} />
              {/* Left for backward compatibility, to be removed in later sprint */}
              <Route path="workorders" element={<WorkOrderList />} />
              <Route path="workorders/view/:workOrderId" element={<WorkOrderView />} />
              <Route path="workorders/scheduledservices/create" element={<ScheduledServicePage />} />
              <Route path="workorders/scheduledservices/view/:scheduledServiceId" element={<ScheduledServicePage />} />
              {/* End backward compatibility */}
              <Route path="repair/work-orders" element={<WorkOrderList />} />
              <Route path="repair/work-orders/:workOrderId" element={<WorkOrderView />} />
              <Route path="repair/scheduled-services" element={<ScheduledServiceList />} />
              <Route path="repair/scheduled-services/:scheduledServiceId" element={<ScheduledServicePage />} />
              <Route path="repair/scheduled-services/create" element={<ScheduledServicePage />} />
              <Route path="reports/users" element={<UsersReport />} />
              <Route path="reports/customer-searches" element={<CustomerSearchesReport />} />
              <Route path="reports/dailySchedule" element={<ReportSchedule />} />
              <Route path="reports/dailySchedule/create" element={<ScheduleReport />} />
              <Route path="reports/dailySchedule/:scheduledReportId" element={<ScheduleReport />} />
              <Route path="reports/payments" element={<PaymentsReport />} />
              <Route path="reports/dailyPayments" element={<DailyPaymentReport />} />
              <Route path="reports/stripePayoutReconciliationReport" element={<StripePayoutReconciliationReport />} />
              <Route path="reports/products" element={<ProductsReport />} />
              <Route path="reports/revenue" element={<Revenue showTable={false} />} />
              <Route path="reports/tax" element={<TaxReport />} />
              <Route path="reports/transactions" element={<TransactionsReport />} />
              <Route path="reports/tax_exempt" element={<TaxExemptReport />} />
              <Route path="reports/deliveryRevenue" element={<DeliveryRevenueReport />} />
              <Route path="reports/salesCommission" element={<SalesCommission />} />
              <Route path="reports/missedRentals" element={<MissedRentalsReport />} />
              <Route path="reports/creditmemos" element={<CreditMemoList />} />
              <Route path="accounting/settings" element={<AccountingSettings />} />
              <Route path="accounting/accounts" element={<AccountTotals />} />
              <Route path="accounting/accounts/:accountId" element={<AccountLedger />} />
              <Route path="accounting/accountingPeriods" element={<AccountingPeriodCloseView />} />
              <Route path="qboaccount" element={<QboAccount />} />
              <Route path="orders" element={<OrderList />} />
              <Route path="orders/create" element={<CreateOrder />} />
              <Route path="orders/createMissed" element={<CreateMissedRental />} />
              <Route path="orders/create_quote" element={<CreateQuote />} />
              <Route path="orders/createCreditMemo" element={<CreateCreditMemo />} />
              <Route path="orders/view/:orderId" element={<OrderViewPage />} />
              <Route path="users/account_requests" element={<AccountRequests />} />
              <Route path="shops" element={<LocationList />} />
              <Route path="admins" element={<AdminUsersList />} />
              <Route path="/admins/:adminId" element={<AdminView />}>
                <Route index element={<Navigate to="setup" replace />} />
                <Route path="setup" element={<AdminUserSetup />} />
                <Route path="password" element={<AdminUserPassword />} />
                <Route path="permissions" element={<AdminUserPermissions />} />
                <Route path="emailSettings" element={<AdminUserEmailNotification />} />
              </Route>
              <Route path="quipli-pay" element={<StripeAccountPage />} />
              <Route path="quipli-pay/setup" element={<StripeAccountSetup />} />
              <Route path="quipli-pay/setupExisting" element={<StripeAccountSetupExisting />} />
              <Route path="quipli-pay/customConnectOnboarding/:stripeAccountId" element={<CustomConnectOnboarding />} />
              <Route path="quipli-pay/payments" element={<StripePayments />} />
              <Route path="quipli-pay/payouts" element={<StripePayouts />} />
              <Route path="quipli-pay/bank" element={<BankDetails />} />
              <Route path="quipli-pay/terminal" element={<TerminalList />} />
              <Route path="payment-config/methods" element={<PaymentMethodConfiguration />} />
              <Route path="admin/profile" element={<AdminProfile />} />
              <Route path="admin/change_password" element={<AdminChangePassword />} />
              <Route path="reviews" element={<CustomerReviews />} />
              {tagPricingV2 && (
                <>
                  <Route path="tagpricing" element={<TagsList />} />
                  <Route path="tagpricing/form" element={<TagEditAdd />} />
                  <Route path="tagpricing/form/:id" element={<TagEditAdd />} />
                </>
              )}
              <Route path="taxcodes" element={<TaxSetup />} />
              <Route path="productUnits" element={<ProductUnitsList />} />
              <Route path="dispatch" element={<DispatchSelector />} />
              <Route path="/emailtemplatesv2" element={<EmailTemplates />} />{' '}
              <Route path="/emailtemplatesv2/edit/:emailTemplateId" element={<EditTemplate />} />
              <Route path="/representatives/roles" element={<RepresentativeList />} />
              <Route path="/representatives/roles/:roleId" element={<RepresentativeRoleView />} />
              <Route path="/representatives/roles/create" element={<CreateRepresentativeRole />} />
              {showPurchaseOrder && (
                <>
                  <Route path="purchase-orders" element={<PurchaseOrderList />} />
                  <Route path="purchase-orders/:purchaseOrderId" element={<PurchaseOrderView />} />
                  <Route path="purchase-orders/create" element={<CreatePurchaseOrder />} />
                  <Route path="/vendors" element={<VendorList />} />
                  <Route path="/vendors/:vendorId" element={<VendorView />}>
                    <Route index element={<Navigate to="general" replace />} />
                    <Route path="general" element={<VendorGeneralForm />} />
                    <Route path="address" element={<VendorAddressForm />} />
                  </Route>
                </>
              )}
              {showInspections && <Route path="inspectionWorkflows" element={<JobConfigs />} />}
            </Route>
            {/* TODO: Remove this when we migrate call-off/extend orders to v2 */}
            {/* This view is handled in legacy view, so we need to redirect to home */}
            <Route path="orderrefundshrink" element={<Navigate to={`${contextPath}manager/home`} replace />} />
            <Route
              path="*"
              element={
                <>
                  {!isMobileOrTablet && <AdminHeader pathsToRemoveActions={pathsToRemoveActions} />}
                  <LegacyView />
                </>
              }
            />
          </Routes>
          {showUpgradePrompt && (
            <div
              id="upgrade-prompt"
              className={classNames(
                'bg-[#333] text-[#f7f7f7] w-[330px] h-[40px] rounded-full z-[100] fixed right-16 bottom-4 border-none text-[14px] py-[10px] px-[13px]',
              )}
              onClick={() => window.location.reload()}
            >
              The app has been updated.
              <span className={classNames('underline pl-1 cursor-pointer')}>Click here to refresh</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
